import "@/App.css";
import useLenis from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Problem } from "@/components/site/Problem";
import { Product } from "@/components/site/Product";
import { Audience } from "@/components/site/Audience";
import { Marquee } from "@/components/site/Marquee";
import { Proof } from "@/components/site/Proof";
import { HowItWorks } from "@/components/site/HowItWorks";
import { ReferEarn } from "@/components/site/ReferEarn";
import { PartnerCTA } from "@/components/site/PartnerCTA";
import { FAQ } from "@/components/site/FAQ";
import { DownloadApps } from "@/components/site/DownloadApps";
import { Footer } from "@/components/site/Footer";
import { LegalPage } from "@/components/site/LegalPage";
import { policies } from "@/lib/policies";

const normalizePath = (path) => path.replace(/\/+$/, "").replace(/^\//, "") || "home";

function App() {
  useLenis();
  const route = normalizePath(window.location.pathname);
  const policy = policies[route];

  if (policy) {
    return (
      <div className="App bg-cream">
        <Nav />
        <LegalPage policy={policy} />
        <Footer />
      </div>
    );
  }

  return (
    <div className="App bg-cream">
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Product />
        <Audience />
        <Marquee />
        <Proof />
        <HowItWorks />
        <ReferEarn />
        <PartnerCTA />
        <FAQ />
        <DownloadApps />
      </main>
      <Footer />
    </div>
  );
}

export default App;
